import { EVENT_TYPE } from '../enum/roles.enum';

// export const CUSTOM_EVENTS = [
//   {
//     id: 1,
//     title: 'Independence Day',
//     start: '2024-07-04',
//     end: '2024-07-04',
//     type: EVENT_TYPE.HOLIDAY,
//   },
//   {
//     id: 2,
//     title: 'Admission Day',
//     start: '2024-08-30',
//     end: '2024-08-30',
//     type: EVENT_TYPE.HOLIDAY,
//   },
//   {
//     id: 3,
//     title: 'Labor Day',
//     start: '2024-09-02',
//     end: '2024-09-02',
//     type: EVENT_TYPE.HOLIDAY,
//   },
//   {
//     id: 4,
//     title: 'Veterans Day',
//     start: '2024-11-11',
//     end: '2024-11-11',
//     type: EVENT_TYPE.HOLIDAY,
//   },
//   {
//     id: 5,
//     title: 'Thanksgiving Break',
//     start: '2024-11-25',
//     end: '2024-11-29',
//     type: EVENT_TYPE.HOLIDAY,
//   },
//   {
//     id: 6,
//     title: 'Winter Break',
//     start: '2024-12-16',
//     end: '2025-01-03',
//     type: EVENT_TYPE.HOLIDAY,
//   },
//   {
//     id: 7,
//     title: 'Dr. Martin Luther King Jr. Day',
//     start: '2025-01-20',
//     end: '2025-01-20',
//     type: EVENT_TYPE.HOLIDAY,
//   },
//   {
//     id: 8,
//     title: "Presidents' Day",
//     start: '2025-02-17',
//     end: '2025-02-17',
//     type: EVENT_TYPE.HOLIDAY,
//   },
//   {
//     id: 9,
//     title: 'Cesar Chavez Day',
//     start: '2025-03-31',
//     end: '2025-03-31',
//     type: EVENT_TYPE.HOLIDAY,
//   },
//   {
//     id: 10,
//     title: 'Spring Break',
//     start: '2025-04-14',
//     end: '2025-04-18',
//     type: EVENT_TYPE.HOLIDAY,
//   },
//   {
//     id: 11,
//     title: 'Armenian Genocide Remembrance Day',
//     start: '2025-04-24',
//     end: '2025-04-24',
//     type: EVENT_TYPE.HOLIDAY,
//   },
//   {
//     id: 12,
//     title: 'Memorial Day',
//     start: '2025-05-26',
//     end: '2025-05-26',
//     type: EVENT_TYPE.HOLIDAY,
//   },
//   {
//     id: 13,
//     title: 'Juneteenth',
//     start: '2025-06-19',
//     end: '2025-06-19',
//     type: EVENT_TYPE.HOLIDAY,
//   },
// ];

export const CUSTOM_EVENTS =
  [
    {
      id: 1,
      title: "New Year's Day",
      start: "2025-01-01",
      end: "2025-01-01",
      type: EVENT_TYPE.HOLIDAY,
    },
    {
      id: 2,
      title: "Martin Luther King Jr. Day",
      start: "2025-01-20",
      end: "2025-01-20",
      type: EVENT_TYPE.HOLIDAY,
    },
    {
      id: 3,
      title: "Presidents' Day",
      start: "2025-02-17",
      end: "2025-02-17",
      type: EVENT_TYPE.HOLIDAY,
    },
    {
      id: 4,
      title: "Memorial Day",
      start: "2025-05-26",
      end: "2025-05-26",
      type: EVENT_TYPE.HOLIDAY,
    },
    {
      id: 5,
      title: "Juneteenth National Independence Day",
      start: "2025-06-19",
      end: "2025-06-19",
      type: EVENT_TYPE.HOLIDAY,
    },
    {
      id: 6,
      title: "Independence Day",
      start: "2024-07-04",
      end: "2024-07-04",
      type: EVENT_TYPE.HOLIDAY,
    },
    {
      id: 7,
      title: "Labor Day",
      start: "2024-09-02",
      end: "2024-09-02",
      type: EVENT_TYPE.HOLIDAY,
    },
    {
      id: 8,
      title: "Veterans Day",
      start: "2024-11-11",
      end: "2024-11-11",
      type: EVENT_TYPE.HOLIDAY,
    },
    {
      id: 9,
      title: "Thanksgiving Day",
      start: "2024-11-28",
      end: "2024-11-28",
      type: EVENT_TYPE.HOLIDAY,
    },
    {
      id: 10,
      title: "Christmas Day",
      start: "2024-12-25",
      end: "2024-12-25",
      type: EVENT_TYPE.HOLIDAY,
    }
  ]